<template>
  <div class="top-bar">
    <div v-if="list.length">
      <MoveSteps :current="1" />
    </div>
    <a-space>
      <a-space style="white-space: nowrap">
        <span> 共 {{ list.length }} 个商品，已选择 {{ selectedList.length }} 个商品 </span>
        <template v-if="list.length">
          <a-checkbox
            v-model:checked="isCheckAll"
            :class="['check-all', { 'is-selected': isCheckAll }]"
            @change="changeIsAll"
            >全选</a-checkbox
          >
          <!-- <a-button type="primary" danger @click="batchDeleteGoods">批量删除</a-button> -->
          <a-popover
            v-model:visible="batchUpdateCategoryVisible"
            title="批量修改商品类目"
            trigger="click"
            placement="rightBottom"
          >
            <template #content>
              <div>
                <MallCategorySelect
                  style="width: 395px"
                  :category="category"
                  :categoryList="categoryList"
                  @change="changeCategory"
                />
                <div style="margin-top: 0.7em">
                  <a-radio-group v-model:value="selectType">
                    <a-radio value="select-goods">勾选商品</a-radio>
                    <a-radio value="goods-category-is-null">仅设置商品分类为空的</a-radio>
                  </a-radio-group>
                </div>
                <p
                  v-show="!selectedList.length && selectType === 'select-goods'"
                  style="font-size: 15px; color: red; font-weight: bold; margin: 0.6em 0"
                >
                  请至少选择一个商品
                </p>
                <p
                  v-show="selectedList.length && selectType === 'select-goods'"
                  style="font-size: 15px; font-weight: bold; margin: 0.6em 0"
                >
                  当前选中【{{ selectedList.length }}】个商品
                </p>
                <a-space style="display: flex; margin-top: 1em; justify-content: flex-end">
                  <a-button type="primary" @click="batchUpdateCategory">确定修改</a-button>
                  <a-button @click="batchUpdateCategoryVisible = false">取消修改</a-button>
                </a-space>
              </div>
            </template>
            <a-button type="primary">批量设置类目</a-button>
          </a-popover>
        </template>
      </a-space>
      <NeedUpdateGoodsList v-show="needUpdateList.length && list.length > 2" :needUpdateList="needUpdateList" />
    </a-space>
    <div v-if="list.length" class="quick-key-tip" style="margin-top: 5px">
      <a-tag color="red"
        >提示：键盘↑(W)键和↓(S)键可切换商品，Tab键可切换审核类型，(A)标记已修改和(D)删除功能是基于当前选中商品</a-tag
      >
    </div>
  </div>
</template>
<script>
import NeedUpdateGoodsList from "./need_update_goods_list";
import MoveSteps from "@/views/moving_function/components/move_steps";
import MallCategorySelect from "@/views/moving_function/components/mall_category_select2";
export default {
  components: { NeedUpdateGoodsList, MoveSteps, MallCategorySelect },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
    needUpdateList: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCheckAll: false,
      batchUpdateCategoryVisible: false,
      category: null,
      selectType: "select-goods",
    };
  },
  methods: {
    batchDeleteGoods() {
      if (!this.selectedList.length) return this.$message.warning("请至少选择一个商品");
      this.$emit(
        "delete-goods",
        this.selectedList.map((item) => item.id)
      );
      this.isCheckAll = false;
    },
    // 确定修改分类
    batchUpdateCategory() {
      if (!this.selectedList.length && this.selectType === "select-goods")
        return this.$message.warning("请至少选择一个商品");
      this.batchUpdateCategoryVisible = this.isCheckAll = false;
      this.$emit("update-goods-category", {
        category: this.category,
        selectType: this.selectType,
      });
    },
    changeCategory(category) {
      this.category = category;
    },
    changeIsAll() {
      this.$emit("select-all", this.isCheckAll);
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
